var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { classNames } from '../../utils/styles';
import { Button, SectionContainer } from '../styles';
import { Avatar, ButtonContainer, Content, Header } from './styles';
export var Welcome = function (_a) {
    var section = _a.section;
    var theme = useTheme();
    var title = section.exibitionName;
    var logo = section.logo, featuredTitle = section.featuredTitle, supportingText = section.supportingText, buttonTitle = section.buttonTitle, buttonLink = section.buttonLink;
    var showHeader = !!title || !!logo;
    var showContentSection = !!featuredTitle || !!supportingText;
    var showButtonSection = !!buttonTitle && !!buttonLink;
    var buttonOnClickHandler = function () { return window.open(buttonLink); };
    return (_jsxs(_Fragment, { children: [showHeader && (_jsx(SectionContainer, { children: _jsxs(Header, __assign({ className: classNames({
                        'avatar-present': !!logo,
                    }) }, { children: [title && (_jsx("div", __assign({ className: classNames('title', {
                                'full-width': !logo,
                            }) }, { children: _jsx("h3", { children: title }, void 0) }), void 0)), logo && (_jsx("div", __assign({ className: classNames('avatar', {
                                'full-width': !title,
                            }) }, { children: _jsx(Avatar, { "$logo": logo }, void 0) }), void 0))] }), void 0) }, void 0)), showContentSection && (_jsx(SectionContainer, __assign({ className: classNames({
                    npb: showButtonSection,
                }) }, { children: _jsxs(Content, { children: [featuredTitle && (_jsx("div", { children: _jsx("h1", { children: featuredTitle }, void 0) }, void 0)), supportingText && (_jsx("div", __assign({ className: classNames('supporting-text', {
                                mt: !!featuredTitle,
                            }) }, { children: _jsx("h5", { children: supportingText }, void 0) }), void 0))] }, void 0) }), void 0)), showButtonSection && (_jsx(SectionContainer, { children: _jsx(ButtonContainer, { children: _jsx(Button, __assign({ onClick: function () { return buttonOnClickHandler(); }, textColor: theme.textButtons, backgroundColor: theme.buttons }, { children: buttonTitle }), void 0) }, void 0) }, void 0))] }, void 0));
};
